export default "__VITE_ASSET__DlN2yshh__"